module.exports = __webpack_public_path__ + "static/media/paint_palette.48da2db7.svg";